module.exports = __webpack_public_path__ + "static/media/logo.53f775cc.png";